import { render, staticRenderFns } from "./coupon_add.vue?vue&type=template&id=3271c33c&"
import script from "./coupon_add.vue?vue&type=script&lang=js&"
export * from "./coupon_add.vue?vue&type=script&lang=js&"
import style0 from "./coupon_add.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports